
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers",
      function () {
        return require("private-next-pages/sneakers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers"])
      });
    }
  